import React, { PropsWithChildren } from 'react';
import styles from './AspectRatio.module.scss';

export const AspectRatio = ({
    children,
    width = 1,
    height = 1
}: Props) => (
    <div className={styles.container}
        style={{ paddingBottom: computePaddingBottom(width, height) }}>
        <div className={styles.element}>
            {children}
        </div>
    </div>
);

const computePaddingBottom = (width: number, height: number) => {
    const aspectRatio = width / height;
    return (100 / aspectRatio) + '%';
};

type Props = PropsWithChildren<{
    width?: number;
    height?: number;
}>;